export const CMS_NAME = "NET";
export const CMS_ENDPOINT = "https://graphql.datocms.com/";

export const SUPPORTED_LOCALES = ["it"];
